import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ReturnCurrentUserDelegationCommand } from "../models/return-current-user-delegation-command.model";
import { ReturnCurrentUserDelegationResult } from "../models/return-current-user-delegation-result.model";
import { SubscriptionInvitation } from "../models/subscription-invitation";

@Injectable({ providedIn: "root" })
export class SubscriptionsService {
    constructor(private httpClient: HttpClient) {}

    public getActiveAndPendingSubscriptions(): Observable<SubscriptionInvitation[]> {
        return this.httpClient.get<SubscriptionInvitation[]>("/api/Invitations/ActiveAndPendingSubscriptions");
    }

    public answerInvitation(
        identityUserId: string,
        subscriptionInvitation: SubscriptionInvitation,
        signature: string,
        accept: boolean,
    ): Observable<boolean> {
        return this.httpClient.post<boolean>("/api/Invitations/AnswerInvitation", {
            identityUserId: identityUserId,
            subscriptionId: subscriptionInvitation.subscriptionId,
            invitationType: subscriptionInvitation.invitationType,
            signature: signature,
            accept: accept,
        });
    }

    public returnCurrentUserDelegation(
        command: ReturnCurrentUserDelegationCommand,
    ): Observable<ReturnCurrentUserDelegationResult> {
        return this.httpClient.post<ReturnCurrentUserDelegationResult>("/api/Delegations/ReturnCurrentUserDelegation", command);
    }
}
